import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { CustomizedLabels } from '@models/models';
import { Subject } from 'rxjs';
import { SettingsProvider } from '@services/settings/settings';

@Component({
	selector: 'quote-client-info',
	template: require('./quote-client-info.html'),
	styles: [require('./quote-client-info.scss')]
})
export class QuoteClientInfoComponent implements OnInit, OnDestroy {
	@Input('job') job;
	@Input() fromQuoteView: boolean;

	businessNumberLabelName: string;
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(private settingsService: SettingsProvider) {}

	ngOnInit(): void {
		this.subscribeToCustomizeLabelsChange();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.businessNumberLabelName = customizeLabels.businessNumberLabel)
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/quotes/common/quote-client-info/quote-client-info.ts